import { Game, Staff, FAQ, ContactMessage, AdminStats } from '../types';

// Fallback mock data in case backend API / D1 database is not connected during static preview
const MOCK_GAMES: Game[] = [
  {
    id: 'game-1',
    title: 'Neon Odyssey',
    slug: 'neon-odyssey',
    description: 'An expansive cyberpunk action RPG set in the vertical mega-city of Neo-Kyoto. Hack rogue neural networks, customize cybernetic loadouts, and command high-speed combat.',
    genre: 'Action RPG',
    status: 'Released',
    thumbnail_url: 'https://images.unsplash.com/photo-1542751371-adc38448a05e?auto=format&fit=crop&w=800&q=80',
    banner_url: 'https://images.unsplash.com/photo-1511512578047-dfb367046420?auto=format&fit=crop&w=1600&q=80',
    play_url: 'https://store.steampowered.com',
    download_url: 'https://store.steampowered.com',
    rating: 4.9,
    tags: ['Cyberpunk', 'Open World', 'Action RPG', 'Ray Tracing'],
    featured: true,
  },
  {
    id: 'game-2',
    title: 'Chrono Shift',
    slug: 'chrono-shift',
    description: 'Rewind, freeze, and accelerate time in this precision tactical puzzle-shooter. Master time anomalies to overcome impossibly fortified orbital stations.',
    genre: 'Tactical Shooter',
    status: 'Early Access',
    thumbnail_url: 'https://images.unsplash.com/photo-1550745165-9bc0b252726f?auto=format&fit=crop&w=800&q=80',
    banner_url: 'https://images.unsplash.com/photo-1518709268805-4e9042af9f23?auto=format&fit=crop&w=1600&q=80',
    play_url: 'https://store.steampowered.com',
    download_url: 'https://store.steampowered.com',
    rating: 4.8,
    tags: ['Time Manipulation', 'Tactical', 'Sci-Fi', 'PvP'],
    featured: true,
  },
  {
    id: 'game-3',
    title: 'Aetheria: Realm of Gods',
    slug: 'aetheria-realm-of-gods',
    description: 'Unleash ancient elemental forces in a mythological rogue-lite dungeon crawler featuring fluid swordplay, divine pacts, and procedurally shifting temples.',
    genre: 'Action Rogue-lite',
    status: 'In Development',
    thumbnail_url: 'https://images.unsplash.com/photo-1538481199705-c710c4e965fc?auto=format&fit=crop&w=800&q=80',
    banner_url: 'https://images.unsplash.com/photo-1579373903781-fd5c0c30c4cd?auto=format&fit=crop&w=1600&q=80',
    play_url: 'https://store.epicgames.com',
    download_url: 'https://store.epicgames.com',
    rating: 4.7,
    tags: ['Rogue-lite', 'Mythology', 'Hack & Slash', 'Co-op'],
    featured: true,
  },
  {
    id: 'game-4',
    title: 'Velocity Zero',
    slug: 'velocity-zero',
    description: 'Extreme anti-gravity combat racing running at blistering sonic speeds. Build custom hover-crafts and dominate supersonic tracks suspended thousands of meters above planetary surfaces.',
    genre: 'Anti-Gravity Racing',
    status: 'Released',
    thumbnail_url: 'https://images.unsplash.com/photo-1552824722-ddab1374e622?auto=format&fit=crop&w=800&q=80',
    banner_url: 'https://images.unsplash.com/photo-1509198397868-475647b2a1e5?auto=format&fit=crop&w=1600&q=80',
    play_url: 'https://store.steampowered.com',
    download_url: 'https://store.steampowered.com',
    rating: 4.6,
    tags: ['Racing', 'Anti-Gravity', 'Fast-Paced', 'Multiplayer'],
    featured: false,
  },
];

const MOCK_STAFF: Staff[] = [
  {
    id: 'staff-1',
    name: 'Alex Mercer',
    role: 'Studio Founder & Game Director',
    bio: '15+ years in AAA game development. Previously lead director on acclaimed sci-fi franchises. Obsessed with high-framerate combat and worldbuilding.',
    avatar_url: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=500&q=80',
    twitter: 'https://twitter.com',
    github: 'https://github.com',
    linkedin: 'https://linkedin.com',
    sort_order: 1,
  },
  {
    id: 'staff-2',
    name: 'Elena Vance',
    role: 'Lead Systems Architect',
    bio: 'Engine whisperer and networking specialist. Pioneering deterministic multiplayer simulation and zero-latency physics pipelines.',
    avatar_url: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?auto=format&fit=crop&w=500&q=80',
    twitter: 'https://twitter.com',
    github: 'https://github.com',
    linkedin: 'https://linkedin.com',
    sort_order: 2,
  },
  {
    id: 'staff-3',
    name: 'Kenji Sato',
    role: 'Principal 3D & Technical Artist',
    bio: 'Bridges fine art with cutting-edge real-time shaders, procedural geometry generation, and cinematic lighting.',
    avatar_url: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=500&q=80',
    twitter: 'https://twitter.com',
    github: 'https://github.com',
    linkedin: 'https://linkedin.com',
    sort_order: 3,
  },
  {
    id: 'staff-4',
    name: 'Maya Lin',
    role: 'Lead Narrative & World Designer',
    bio: 'Award-winning speculative fiction author turned interactive storyteller. Crafting deep lore, emotional character arcs, and branching choices.',
    avatar_url: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=500&q=80',
    twitter: 'https://twitter.com',
    github: 'https://github.com',
    linkedin: 'https://linkedin.com',
    sort_order: 4,
  },
];

const MOCK_FAQS: FAQ[] = [
  {
    id: 'faq-1',
    question: 'What platforms does GSR STUDIO develop for?',
    answer: 'Our titles target PC (Steam, Epic Games Store) and current-gen consoles (PlayStation 5, Xbox Series X/S). Selected projects also feature cross-platform play.',
    category: 'General',
    sort_order: 1,
  },
  {
    id: 'faq-2',
    question: 'What game engines and technologies do you use?',
    answer: 'We specialize in custom Unreal Engine 5 C++ pipelines, high-performance Vulkan/DirectX12 graphics, and Cloudflare edge architectures for multiplayer matchmaking and services.',
    category: 'Technology',
    sort_order: 2,
  },
  {
    id: 'faq-3',
    question: 'How can I join the GSR STUDIO alpha/beta playtests?',
    answer: 'You can sign up for testing by following our news updates, joining our official community, or contacting us through our Contact page with your playtesting hardware specifications.',
    category: 'Community',
    sort_order: 3,
  },
  {
    id: 'faq-4',
    question: 'Is GSR STUDIO hiring?',
    answer: 'We are always looking for passionate engineers, 3D artists, and combat designers! Check our Staff page and send your portfolio or resume to careers@gsrstudio.dev.',
    category: 'Careers',
    sort_order: 4,
  },
  {
    id: 'faq-5',
    question: 'Are creators allowed to stream and monetize GSR STUDIO games?',
    answer: 'Yes! We encourage content creators, streamers, and reviewers to stream, record gameplay, and monetize their content under our standard creator guidelines.',
    category: 'Community',
    sort_order: 5,
  },
];

const API_BASE = '/api';

export const api = {
  // Games
  async getGames(): Promise<Game[]> {
    try {
      const res = await fetch(`${API_BASE}/games`);
      if (!res.ok) throw new Error('API request failed');
      const data = await res.json();
      return data.games && data.games.length > 0 ? data.games : MOCK_GAMES;
    } catch {
      return MOCK_GAMES;
    }
  },

  async getGameBySlug(slug: string): Promise<Game | null> {
    try {
      const res = await fetch(`${API_BASE}/games/${slug}`);
      if (!res.ok) throw new Error('API request failed');
      const data = await res.json();
      return data.game || null;
    } catch {
      return MOCK_GAMES.find((g) => g.slug === slug) || null;
    }
  },

  async createGame(game: Partial<Game>, adminKey: string): Promise<any> {
    const res = await fetch(`${API_BASE}/games`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${adminKey}`,
      },
      body: JSON.stringify(game),
    });
    return res.json();
  },

  async updateGame(id: string, game: Partial<Game>, adminKey: string): Promise<any> {
    const res = await fetch(`${API_BASE}/games/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${adminKey}`,
      },
      body: JSON.stringify(game),
    });
    return res.json();
  },

  async deleteGame(id: string, adminKey: string): Promise<any> {
    const res = await fetch(`${API_BASE}/games/${id}`, {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${adminKey}`,
      },
    });
    return res.json();
  },

  // Staff
  async getStaff(): Promise<Staff[]> {
    try {
      const res = await fetch(`${API_BASE}/staff`);
      if (!res.ok) throw new Error('API request failed');
      const data = await res.json();
      return data.staff && data.staff.length > 0 ? data.staff : MOCK_STAFF;
    } catch {
      return MOCK_STAFF;
    }
  },

  async createStaff(member: Partial<Staff>, adminKey: string): Promise<any> {
    const res = await fetch(`${API_BASE}/staff`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${adminKey}`,
      },
      body: JSON.stringify(member),
    });
    return res.json();
  },

  async deleteStaff(id: string, adminKey: string): Promise<any> {
    const res = await fetch(`${API_BASE}/staff/${id}`, {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${adminKey}`,
      },
    });
    return res.json();
  },

  // FAQs
  async getFAQs(): Promise<FAQ[]> {
    try {
      const res = await fetch(`${API_BASE}/faqs`);
      if (!res.ok) throw new Error('API request failed');
      const data = await res.json();
      return data.faqs && data.faqs.length > 0 ? data.faqs : MOCK_FAQS;
    } catch {
      return MOCK_FAQS;
    }
  },

  async getFaqs(): Promise<FAQ[]> {
    return this.getFAQs();
  },

  async createFAQ(faq: Partial<FAQ>, adminKey: string): Promise<any> {
    const res = await fetch(`${API_BASE}/faqs`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${adminKey}`,
      },
      body: JSON.stringify(faq),
    });
    return res.json();
  },

  async deleteFAQ(id: string, adminKey: string): Promise<any> {
    const res = await fetch(`${API_BASE}/faqs/${id}`, {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${adminKey}`,
      },
    });
    return res.json();
  },

  // Contacts
  async sendContact(data: { name: string; email: string; subject: string; message: string }): Promise<any> {
    const res = await fetch(`${API_BASE}/contact`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    return res.json();
  },

  async submitContact(data: { name: string; email: string; subject: string; message: string }): Promise<any> {
    return this.sendContact(data);
  },

  async getContacts(adminKey: string): Promise<ContactMessage[]> {
    const res = await fetch(`${API_BASE}/contacts`, {
      headers: { Authorization: `Bearer ${adminKey}` },
    });
    const data = await res.json();
    return data.contacts || [];
  },

  // Admin
  async adminLogin(adminKey: string): Promise<{ success: boolean; token?: string; error?: string }> {
    const res = await fetch(`${API_BASE}/admin/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ adminKey }),
    });
    return res.json();
  },

  async getAdminStats(adminKey: string): Promise<AdminStats> {
    const res = await fetch(`${API_BASE}/admin/stats`, {
      headers: { Authorization: `Bearer ${adminKey}` },
    });
    return res.json();
  },

  async initDB(adminKey: string): Promise<any> {
    const res = await fetch(`${API_BASE}/admin/init-db`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${adminKey}` },
    });
    return res.json();
  },
};
